angular.module('dpw.services')
  .factory('contentfulService', ['$q', 'api', 'dpwStorage', function ($q, api, dpwStorage) {
    var storageKey = 'CONTENTFUL_ENABLED';
    var lang = RCDPW.Lang.Contentful;
    var siteWidePromise;

    RCDPW.enableContentful = function (enable) {
      dpwStorage.setItem(storageKey, enable);
    };

    return {
      isEnabled: function () {
        return dpwStorage.getItem(storageKey) !== 'false';
      },
      getSiteWide: function () {
        if (!siteWidePromise) {
          siteWidePromise = this.getTexts(api.contentful.siteWide, lang.SiteWide);
        }

        return siteWidePromise;
      },

      getHomePage: function () {
        return this.getTexts(api.contentful.homePage, lang.HomePage);
      },

      /**
       * @param {function} textsApi
       * @returns {*}
       */
      getTexts: function (textsApi, localLang) {
        var self = this;
        return $q(function(resolve, reject) {
          if (!self.isEnabled()) {
            reject();
            return;
          }

          api.call(textsApi(), angular.noop, angular.noop)
            .then(function (res) {
              try {
                var content = res.content || {};
                var result = {};

                _.forEach(content, function (languages, key) {
                  result[key] = languages['en-US'];
                });

                result = _.assign(localLang, result);
                resolve(result);
              } catch(err) {
                reject(err);
              }
            }, function() {
                reject();
            });
        });
      }
    };
  }]);
